import styled from '@emotion/styled'

export interface PriceWrapperProps {
  color?: 'primary' | 'secondary' | 'tertiary'
  strike?: boolean
  // Causes a TS error in nebula if imported directly from DefaultFontStyles
  fontStyle?:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'p1'
    | 'p2'
    | 'p3'
    | 'p4'
}

/**
 * `PriceWrapper` is a styling helper used when rendering a collection of Price themed
 * components together, such as `PriceText` and `Price`. Use `PriceWrapper` when you
 * need to render `Price` with other components, otherwise `Price` alone should suffice.
 */
export const PriceWrapper = styled.div<PriceWrapperProps>(
  ({ theme, fontStyle = 'h6', color = 'primary', strike = false }) => ({
    color: theme.colors.text[color],
    ...theme.fontStyle[fontStyle],
    display: 'inline-flex',
    alignItems: 'baseline',
    textDecoration: strike ? 'line-through' : undefined
  })
)

export const PriceText = styled.span<PriceWrapperProps>(
  ({ theme, fontStyle = 'h6', color = 'primary', strike = false }) => ({
    color: theme.colors.text[color],
    ...theme.fontStyle[fontStyle],
    whiteSpace: 'pre',
    textDecoration: strike ? 'line-through' : undefined
  })
)
